module.exports = __webpack_public_path__ + "img/switch-off.108f7a40.png";